import { Type, UpdateTypeRequest, UpdateTypeResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Type };
export const updateType = makeCloudFunction<
  UpdateTypeRequest,
  UpdateTypeResponse
>("type", "updateType");
